import { render, staticRenderFns } from "./SubEventTab.vue?vue&type=template&id=40cc4316&"
import script from "./SubEventTab.vue?vue&type=script&lang=js&"
export * from "./SubEventTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports